module.exports = __webpack_public_path__ + "static/media/item1.8c508dfe.png";